const _version = "3.8.0 "
function version() {
    return _version
}
export default version
